import React, { FC } from "react";
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';

export interface CheckoutFormProps {
  className?: string;
  clientSecret: string;
  bookings: any;
}
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
if (!stripePublishableKey) {
  console.error(
    "Missing REACT_APP_STRIPE_PUBLISHABLE_KEY env var — Stripe checkout will not work."
  );
}
const stripePromise = loadStripe(stripePublishableKey || "");

const CheckoutForm: FC<CheckoutFormProps> = ({
  clientSecret,
  bookings
}) => {
  const options = { clientSecret };
  return (
    <EmbeddedCheckoutProvider
      stripe={stripePromise}
      options={options}
    >
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>

  );
};

export default CheckoutForm;
